import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useUserIntakePreferencesFetcher = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)

  const fetchData = useCallback(async () => {
    try {
      const { data } = await RequestService.getUserPreferences()

      setData(data)
    } catch (e) {
      console.log('useUserIntakePreferencesFetcher', e)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return { loading, data }
}

export default useUserIntakePreferencesFetcher
